import React from "react";
import { Modal, Row, Col } from "react-bootstrap";

const CreditCardPaymentModal = ({
  title,
  amount,
  date,
  show,
  updateModalShow,
  resetValues,
  isScheduled,
  isAutopay,
  callbackFunction,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        updateModalShow(false);
      }}
      className="modal-style-1 w-100"
      size="lg"
    >
      <Modal.Header>
        <Modal.Title as="h3" className="w-100 text-center">
          Continue to Pay with Card
        </Modal.Title>
      </Modal.Header>

      {/* ARR-1417 - adjusted modal body to reflect Tenant Payment Notice 24 Hours to Withdraw from Bank Account */}

      <Modal.Body>
        <div className="text-center">
          <p className=" mb-3">
            Please note that all credit card payments will incur a fee of 2.9% + $0.30 per transaction.
          </p>
        </div>
      </Modal.Body>
      <Row>
        <Col xxl={6} xl={12}>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={() => {
              resetValues();
              updateModalShow(false);
            }}
          >
            Back
          </button>
        </Col>
        <Col xxl={6} xl={12}>
          <button
            onClick={() => {
              callbackFunction();
              updateModalShow(false);
            }}
            type="button"
            className="btn btn-primary w-100 mt-4 mt-xl-0"
            data-cy="continue"
          >
            Continue To Payment
          </button>
        </Col>
      </Row>
    </Modal>
  );
};
export default CreditCardPaymentModal;
